// Filters the calculators registry by a free-text query.
import { useMemo } from "react";
import { CALCULATORS } from "@/lib/calculators";

const MAX_RESULTS = 6;

export default function useCalcSearch(query) {
  return useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return [];
    return CALCULATORS.filter((c) => {
      const hay = (c.title + " " + c.description + " " + c.tags.join(" ")).toLowerCase();
      return hay.includes(q);
    }).slice(0, MAX_RESULTS);
  }, [query]);
}
